import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

import { HeadLine } from '@/components/common/HeadLine';
import KeywordRanking from '@/components/common/KeywordRanking';
import Pagination from '@/components/Pagination';

import useStore from '@/hooks/useStore';
import { useSearchParams } from '@popularKeyword/common-hooks';

import { createTitleByCategoryName } from '@popularKeyword/common-utils';
import { getDetail } from '@/utils/api';

const Detail = () => {
  const { SEOStore } = useStore();
  const { setSEOData } = SEOStore;

  const { rising, category, page, date } = useSearchParams();

  const [data, setData] = useState<any>();
  const [currentPage, setCurrentPage] = useState<number>(Number(page));

  useEffect(() => {
    const fetchDetailData = async () => {
      const detailData = await getDetail({
        currentPage: currentPage,
        date: date,
        category: category,
        rising: rising,
      });
      setData(detailData);

      const { seo } = detailData;
      setSEOData(seo);
    };

    fetchDetailData();
    window.scrollTo(0, 0);
  }, [currentPage, date, category, rising, setSEOData]);

  if (!data) return null;

  const { title, item, categoryName } = data;

  return (
    <div className="l_content" role="main">
      <div className="s_keyword">
        <div className="l_keyword_head sr-only">
          <div className="c-p-headline">
            <h2 className="c-p-headline__title">인기 키워드</h2>
          </div>
        </div>
        <div className="l_keyword_content">
          <div className="keyword-ranking">
            <HeadLine title={categoryName ? createTitleByCategoryName({ title, categoryName }) : title} />
            <KeywordRanking keywordRankingData={item} />
            <Pagination setPage={setCurrentPage} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(Detail);
